import { render, staticRenderFns } from "./PackageSizes.vue?vue&type=template&id=492c9fda&scoped=true&"
import script from "./PackageSizes.vue?vue&type=script&lang=js&"
export * from "./PackageSizes.vue?vue&type=script&lang=js&"
import style0 from "./PackageSizes.vue?vue&type=style&index=0&id=492c9fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c9fda",
  null
  
)

export default component.exports